import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CheckType } from '../enums/check-type.enum';
import { CheckConfig } from './check.component';

@Injectable({
  providedIn: 'root'
})
export class CheckService {

  private subject = new Subject<CheckConfig>();

  constructor() { }

  notify(type: CheckType, message: string, callbcak?: (clickButton?: string) => void, size?: string) {
    const config: CheckConfig = {
      type,
      message,
      callbcak,
      size,
    }
    this.subject.next(config);
  }

  open(): Observable<CheckConfig> {
    return this.subject.asObservable();
  }

}
